module.exports = __webpack_public_path__ + "media/common/images/innogy_style/personal-growth-808f1965ca1adfbb880c30572bc751ec.svg";